/**
 * Type of relationship between two or more market segments.
 * tag: 2547
 * @readonly
 * @enum {number} (int)
 */
export enum MarketSegmentRelationship {
  MarketSegmentPoolMember = 1,
  RetailSegment = 2,
  WholesaleSegment = 3,
}
